import { useMemo, useState } from 'react';
import axios from 'axios';
import { useNavigate, useParams } from 'react-router-dom';
import { FiEye, FiEyeOff, FiSave, FiArrowLeft } from 'react-icons/fi';
import './styles/auth.css';

import CAMPUS_IMG from './assets/kampus_A.png';
import ikona from './assets/icon.png';

export default function ResetHaslaUstaw() {
    const { token } = useParams();
    const navigate = useNavigate();

    const [pwd1, setPwd1] = useState('');
    const [pwd2, setPwd2] = useState('');
    const [showPwd, setShowPwd] = useState(false);

    const [blad, setBlad] = useState('');
    const [ok, setOk] = useState('');
    const [loading, setLoading] = useState(false);

    const same = useMemo(() => pwd1 && pwd2 && pwd1 === pwd2, [pwd1, pwd2]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setBlad('');
        setOk('');

        if (!token) {
            setBlad('Brak tokenu resetu.');
            return;
        }
        if (pwd1.length < 8) {
            setBlad('Hasło musi mieć co najmniej 8 znaków.');
            return;
        }
        if (pwd1 !== pwd2) {
            setBlad('Hasła nie są takie same.');
            return;
        }

        setLoading(true);
        try {
            const res = await axios.post('/api/uzytkownicy/reset-hasla/confirm', {
                token,
                noweHaslo: pwd1
            });
            setOk(res.data?.msg || 'Hasło zostało zmienione. Możesz się zalogować.');
        } catch (err) {
            setBlad(err.response?.data?.blad || 'Nie udało się zmienić hasła.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div
            className="auth-hero-bg"
            style={{ backgroundImage: `url("${CAMPUS_IMG}")` }}
            role="img"
            aria-label="Zdjęcie kampusu uczelni w tle"
        >
            <div className="auth-glass">
                <div className="auth-head">
                    <div className="auth-badge" aria-hidden>
                        <img src={ikona} alt="Logo" style={{ height: '80px', width: '64px' }} />
                    </div>
                    <div>
                        <h1 className="auth-title">Ustaw nowe hasło</h1>
                    </div>
                </div>

                <div className="auth-msg">
                    {!!ok && (
                        <div className="auth-ok">
                            {ok}{' '}
                            <button className="auth-link" onClick={() => navigate('/')} style={{ marginLeft: 8 }}>
                                Przejdź do logowania
                            </button>
                        </div>
                    )}
                    {!!blad && <div className="auth-err">{blad}</div>}
                </div>

                <form onSubmit={handleSubmit}>
                    <div className="auth-field">
                        <label htmlFor="pwd1" className="auth-label">Nowe hasło</label>
                        <div className="auth-input-wrap">
                            <input
                                id="pwd1"
                                className="auth-input"
                                type={showPwd ? 'text' : 'password'}
                                placeholder="••••••••"
                                value={pwd1}
                                onChange={(e) => setPwd1(e.target.value)}
                                autoComplete="new-password"
                                required
                            />
                            <button
                                type="button"
                                className="auth-eye"
                                onClick={() => setShowPwd(v => !v)}
                                aria-label={showPwd ? 'Ukryj hasło' : 'Pokaż hasło'}
                                title={showPwd ? 'Ukryj hasło' : 'Pokaż hasło'}
                            >
                                {showPwd ? <FiEyeOff size={18} /> : <FiEye size={18} />}
                            </button>
                        </div>
                    </div>

                    <div className="auth-field">
                        <label htmlFor="pwd2" className="auth-label">Powtórz hasło</label>
                        <div className="auth-input-wrap">
                            <input
                                id="pwd2"
                                className="auth-input"
                                type={showPwd ? 'text' : 'password'}
                                placeholder="••••••••"
                                value={pwd2}
                                onChange={(e) => setPwd2(e.target.value)}
                                autoComplete="new-password"
                                required
                            />
                        </div>
                        {pwd1 && pwd2 && (
                            <div style={{ marginTop: 8, fontSize: 12, opacity: 0.9 }}>
                                {same ? '✅ Hasła są zgodne' : '❌ Hasła różnią się'}
                            </div>
                        )}
                    </div>

                    <button type="submit" className="auth-cta" disabled={loading || !!ok}>
                        <FiSave size={18} />
                        {loading ? 'Zapisuję...' : 'Zmień hasło'}
                    </button>
                </form>

                <div className="auth-foot">
                    <button className="auth-link" onClick={() => navigate('/')} style={{ display: 'inline-flex', gap: 8, alignItems: 'center' }}>
                        <FiArrowLeft /> Wróć do logowania
                    </button>
                </div>
            </div>

            <div className="auth-legal">
                © {new Date().getFullYear()} Gdańska Akademia Medyczna Nauk Stosowanych
            </div>
        </div>
    );
}
